// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module__title___2Ntg5","text":"index-module__text___1VF80","tvs":"index-module__tvs___1nIRZ"};